const ActionTypes = {
	add: 'FlashMessage.add',
	remove: 'FlashMessage.remove',
	removeByText: 'FlashMessage.removeByText',
	timeout: 'FlashMessage.timeout',
	reset: 'FlashMessage.reset',
	cancelDismiss: 'FlashMessage.cancelDismiss',
	scheduleDismiss: 'FlashMessage.scheduleDismiss',
};

export default ActionTypes;
